// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"Checkbox__checkbox___1qRcU","radio":"Checkbox__radio___CjF04","spanIcon":"Checkbox__spanIcon___2GpZC","hasError":"Checkbox__hasError___1To-_","errorBlock":"Checkbox__errorBlock___3LQ08","radio-out":"Checkbox__radio-out___28YTT","radio-in":"Checkbox__radio-in___3UXGM","checky-out":"Checkbox__checky-out___1PZz1"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/Checkbox.less
 ** module id = 756
 ** module chunks = 0
 **/